<script lang="ts" setup>
import dayjs from 'dayjs';

const { date } = defineProps<{ date: string | null }>();

const isExpired = computed(() => dayjs(date).isBefore(dayjs()));

const now = ref(dayjs());

function updateNow() {
  now.value = dayjs();
}

const daysLeft = computed(() => {
  return dayjs(date).diff(now.value, 'day');
});

const hoursLeft = computed(() => {
  return dayjs(date).subtract(daysLeft.value, 'day').diff(now.value, 'hour');
});

const minutesLeft = computed(() => {
  return dayjs(date).subtract(daysLeft.value, 'day').subtract(hoursLeft.value, 'hour').diff(now.value, 'minute');
});

const secondsLeft = computed(() => {
  return dayjs(date)
    .subtract(daysLeft.value, 'day')
    .subtract(hoursLeft.value, 'hour')
    .subtract(minutesLeft.value, 'minute')
    .diff(now.value, 'second');
});

let timerInterval = null;

onMounted(() => {
  timerInterval = setInterval(() => updateNow(), 1000);
});

onBeforeUnmount(() => {
  clearInterval(timerInterval);
});
</script>

<template>
  <div
    v-if="date && !isExpired"
    class="countdown-timer"
  >
    <SvgoClock
      :font-controlled="false"
      class="size-5 mr-1 -mt-0.5"
      filled
    />

    <div
      v-if="daysLeft"
      class="countdown-timer__block"
    >
      <div>{{ daysLeft }}</div>

      <div class="countdown-timer__block-text">дней</div>
    </div>

    <div v-if="daysLeft">:</div>

    <div
      v-if="hoursLeft > 0 || daysLeft > 0"
      class="countdown-timer__block"
    >
      <div>{{ hoursLeft }}</div>

      <div class="countdown-timer__block-text">часов</div>
    </div>

    <div v-if="hoursLeft > 0 || daysLeft > 0">:</div>

    <div
      v-if="minutesLeft > 0 || hoursLeft > 0 || daysLeft > 0"
      class="countdown-timer__block"
    >
      <div>{{ minutesLeft }}</div>

      <div class="countdown-timer__block-text">минут</div>
    </div>

    <div v-if="minutesLeft > 0 || hoursLeft > 0 || daysLeft > 0">:</div>

    <div class="countdown-timer__block">
      <div>{{ secondsLeft }}</div>

      <div class="countdown-timer__block-text">секунд</div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.countdown-timer {
  display: flex;
  gap: 4px;
  align-items: flex-start;
  color: $hell-black-60;

  &__block {
    display: flex;
    flex-direction: column;
    gap: 4px;
    align-items: center;
  }

  &__block-text {
    color: $hell-black-40;
    font-size: $text-xs;
  }
}
</style>
